module.exports = __webpack_public_path__ + "images/external_images/img/700x400/img1.jpg";